import listActions from 'src/modules/habilidad/list/habilidadListActions';
import HabilidadService from 'src/modules/habilidad/habilidadService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'HABILIDAD_DESTROY';

const habilidadDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: habilidadDestroyActions.DESTROY_STARTED,
      });

      await HabilidadService.destroyAll([id]);

      dispatch({
        type: habilidadDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.habilidad.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/habilidad');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: habilidadDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: habilidadDestroyActions.DESTROY_ALL_STARTED,
      });

      await HabilidadService.destroyAll(ids);

      dispatch({
        type: habilidadDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.habilidad.destroyAll.success'),
      );

      getHistory().push('/habilidad');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: habilidadDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default habilidadDestroyActions;
